import { history } from "../_helpers";

export const companyServices = {
  getCompanyDetails,
  editCompanyProfile,
  getCompanyLogo,
  getDashboardDropdownData,
  getCostDashboardData
};

function getCompanyDetails() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company`,
    requestOptions
  ).then(handleResponse);
}

function editCompanyProfile(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
    },
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company`,
    requestOptions
  ).then(handleResponse);
}

function getCompanyLogo() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company/logo`,
    requestOptions
  ).then(handleResponse);
}

function getDashboardDropdownData() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company/dashboard-dropdown-data`,
    requestOptions
  ).then(handleResponse);
}

function getCostDashboardData(filters) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(filters)
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company/cost-dashboard-data`,
    requestOptions
  ).then(handleResponse);
}



function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // // location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
